
import $ from "jquery"
import _bind from "lodash/bind"

interface PaginationSelector {
  all: string,
  with_data: string,
  active_page: string
}
interface PaginationDuck {
  $main: JQuery

  init(main: string, selector: PaginationSelector): PaginationDuck
  initEvent(): PaginationDuck
  getPage(): number
  setPage(n: number): PaginationDuck
  resetPage(): PaginationDuck
  onDataClick(f: (e: Event) => void): PaginationDuck
  onUpdate(f: (page: number) => void): PaginationDuck
}


// ====== constants =========
const DEFAULT_PAGE_NO:  number = 1
const DEFAULT_SELECTOR: PaginationSelector = {
  all:          ".pagination a",
  with_data:    ".pagination a[href][data-page]",
  active_page:  ".pagination__page-link--active a",
}

class Pagination implements PaginationDuck {
  public $main: JQuery

  private currentPageNo: number
  private selector: PaginationSelector

  private onDataClickCallbacks: Array<(e: Event) => void>

  constructor() {
    this.currentPageNo  = DEFAULT_PAGE_NO
    this.selector       = DEFAULT_SELECTOR
    this.$main          = $("div")

    this.onDataClickCallbacks = []
  }

  public init(main: string | Element | JQuery, selector?: PaginationSelector): PaginationDuck {
    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)
    this.$main = $(main)

    this._sync_from_html()

    return this
  }

  public initEvent(): PaginationDuck {
    const { all: $all, with_data: $with_data} = this.selector

    this.$main.on("click", $all, (e) => e.preventDefault())
    this.$main.on("click", $with_data, _bind(this._onDataClick, this))

    return this
  }

  public getPage(): number {
    return this.currentPageNo
  }

  public setPage(pageNo: number): PaginationDuck {
    this.currentPageNo = pageNo
    return this
  }

  public resetPage(): PaginationDuck {
    this.currentPageNo = DEFAULT_PAGE_NO
    return this
  }

  public onDataClick(f: (e: Event) => void): PaginationDuck {
    this.onDataClickCallbacks.push(f)

    return this
  }

  public onUpdate(f: (page: number) => void): PaginationDuck {
    // No this binding
    this._onUpdate = f

    return this
  }

  private _onDataClick(e: Event): void {
    this.onDataClickCallbacks.forEach((f) => f(e))

    this._onDataClickDefault(e)
  }

  private _onDataClickDefault(e: Event): void {
    e.preventDefault()

    if ( e.currentTarget == null ) { return }
    const $el = $(e.currentTarget)
    const _targetPage: number | null = $el.data("page")

    if (typeof _targetPage === "number" && this.currentPageNo !== _targetPage){
      this.setPage(_targetPage)
      this._onUpdate(_targetPage)
    }
  }

  private _onUpdate(_page: number): void {
    // Empty
  }

  private _sync_from_html(): PaginationDuck {
    // by "activated link(css)"
    const $active_page = $(this.selector.active_page)
    // if they start at map view so we can only guess the page
    // TODO: handle this situation in map view / filters instead
    let pageNo = DEFAULT_PAGE_NO
    if ($active_page.length !== 0) {
      // if they start at listing page
      pageNo = $active_page.data("page")
    }

    this.setPage(pageNo)

    return this
  }
}

const Factory = {
  create(){
    return new Pagination()
  },
}

export {
  Factory,
  Pagination,
  Factory as default,
}


